/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer, VApplication } from '../../../../../application';
import { ApplicationDetailPageService } from '../../../services';
import { toast } from 'react-hot-toast';

const MODULE_NAME = 'terminateWorkPermit.machines.states.getPage';

const getSrv = () => {
  return vappContainer.get<ApplicationDetailPageService>(
    ApplicationDetailPageService.displayName
  );
};

export const terminateWorkPermit = async (context: any, event: any) => {
  console.log(`in terminateWorkPermit state :`, event);
  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const src = getSrv();

      const data: any = await src.agent.terminateWorkPermit(event?.payload);
      console.log(`payload in terminateWorkPermit ::::`, event?.payload, data);
      if (data) {
        toast.success(
          `Work permit - ${data?.credentialNo} applied for termination successfully`
        );
        return resolve({
          key: 'TERMINATE_WP_SUCCESS',
          value: {
            ...(data || {}),
          },
        });
      } else {
        console.log('received->', context['TERMINATE_WP_ERROR']?.message);
        toast.error(context['TERMINATE_WP_ERROR']?.message);
        return reject({
          key: 'TERMINATE_WP_ERROR',
          value: 'Failed to submit application',
        });
      }
    } catch (err: any) {
      console.log('received->', context['TERMINATE_WP_ERROR']?.message);

      toast.error(context['TERMINATE_WP_ERROR']?.message);
      return reject({
        key: 'TERMINATE_WP_ERROR',
        value: err?.message,
      });
    }
  });
};
